import React, { useState, useRef } from "react";
import "antd/dist/reset.css";
import CalendarApp from "./Calendar";
import AppointmentForm from "./Form";
import { FaLocationDot } from "react-icons/fa6";
import dayjs from "dayjs";
import { COMPANY_LOGO } from "../../../constants";

function AddAppointment() {

  const formRef = useRef(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [isAppointmentFormVisible, setIsAppointmentFormVisible] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  const generateTimeSlots = (startTime, endTime, date) => {
    const slots = [];

    const today = dayjs().format("YYYY-MM-DD"); // Get today's date


    let start = dayjs.tz(`${today} ${startTime}`, "YYYY-MM-DD HH:mm:ss", "America/New_York");
    let end = dayjs.tz(`${today} ${endTime}`, "YYYY-MM-DD HH:mm:ss", "America/New_York");


    const currentDate = dayjs().format("YYYY-MM-DD");

    if (date === currentDate) {
      let now = dayjs().tz("America/New_York");

      // Round up to the nearest hour if minutes are not zero
      if (now.minute() > 0) {
        now = now.add(1, "hour").startOf("hour");
      }
      // If current time is later than the start time, update start
      if (now.isAfter(start)) {
        start = now;
      }
    }

    // Generate time slots every 5 minutes
    while (start.isBefore(end)) {
      slots.push(start.format("hh:mm A")); // Format as 12-hour time
      start = start.add(5, "minute");
    }
    return slots;
  };


  const handleDateClick = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
    setIsAppointmentFormVisible(false);

    const day = new Date(date).getUTCDate().toString().padStart(2, '0'); // Extract selected day

    // Filter API response for matching day
    const matchedSchedules = appointments.filter((item) => item.day === day);


    if (matchedSchedules.length > 0) {
      let slots = [];
      matchedSchedules.forEach((schedule) => {
        slots = [...slots, ...generateTimeSlots(schedule.start_time, schedule.end_time, schedule.date)];
      });
      // Sort slots with AM first and PM after
      slots.sort((a, b) => {
        const timeA = new Date(`1970-01-01T${convertTo24Hour(a)}`);
        const timeB = new Date(`1970-01-01T${convertTo24Hour(b)}`);
        return timeA - timeB;
      });
      setTimeSlots(slots);
    } else {
      setTimeSlots([]);
    }
  };

  // Helper function to convert 12-hour time to 24-hour time
  const convertTo24Hour = (time) => {
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':');
    if (modifier === 'PM' && hours !== '12') {
      hours = String(parseInt(hours, 10) + 12);
    }
    if (modifier === 'AM' && hours === '12') {
      hours = '00';
    }
    return `${hours.padStart(2, '0')}:${minutes}`;
  };

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot);
    setIsAppointmentFormVisible(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          padding: "5px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
          marginBottom: "5px",
        }}
      >
        <div
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRight: "1px solid #ccc",
            width: "40%",
          }}
        >
          <div className="mb-20">
            <div className="mt-10 mb-5 flex justify-center">
              <img
                src={COMPANY_LOGO}
                alt=""
                style={{ width: "230px", height: "60px"}}   
              />

            </div>
            <div className="flex justify-center flex-col gap-2  ">
              <h1 style={{ fontSize: "15px", fontWeight: "bolder" }}>
                One Car Appointment
              </h1>
              <p className="flex items-center text-primary"><span><FaLocationDot style={{ width: 20, height: 18 }} /></span> 3902 SWINGLE RD HOUSTON TX 77047</p>
            </div>
            <div className="mt-4 mb-8" style={{ fontSize: "12px" }}>
              <p>Please be on time for your appointment.</p>
              <p>Please sign in at the receiving, when you arrive.</p>
            </div>
            <div>
              <h1 className="text-center font-extrabold text-base">Note</h1>
              <ul
                style={{
                  listStyleType: "decimal",
                  paddingLeft: "10px",
                  lineHeight: "1.8",
                  fontSize: "12px",
                  gap: "15px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <li>
                  Please note that if trucker/driver fails to show up as per
                  the scheduled appointment,
                  The Appointment will be considered as cancelled, and the
                  customer will have to reschedule.
                </li>
                <li>
                  The trucker/driver must bring the hard copy of the dispatch
                  sheet at the time of delivery.
                </li>
                <li>
                  Ctrade will not accept the vehicle/s if the aforementioned
                  conditions are not fulfilled.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          
          <div style={{ padding: "20px", width: "55%", marginBottom: "50px" }}>
            <h1 style={{ marginBottom: "20px", fontSize: "24px" }}>
              Select Date And Time
            </h1>
            <CalendarApp onDateClick={handleDateClick} setAppointments={setAppointments} />
          </div>

          {selectedDate && (
            <div className="mt-16 pl-32 w-1/2">
              <h1 style={{ fontSize: "15px" }}>
                {new Date(selectedDate).toLocaleString("default", {
                  weekday: "long",
                  month: "short",
                  day: "numeric",
                  timeZone: "UTC"
                })}
              </h1>
              <div style={{ maxHeight: "400px", overflowY: 'auto', whiteSpace: "nowrap" }} className="scrollable-container">
                {timeSlots.length > 0 ? (
                  timeSlots.map((slot, index) => (
                    <p
                      key={index}
                      onClick={() => handleSlotClick(slot)}
                      style={{
                        border: "1px solid #B83D3D",
                        padding: "10px",
                        textAlign: "center",
                        borderRadius: "8px",
                        marginBottom: "18px",
                        width: "65%",
                        cursor: "pointer",
                        color: selectedSlot === slot ? "white" : "black",
                        backgroundColor:
                          selectedSlot === slot ? "#F04949" : "transparent",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      {slot}
                    </p>
                  ))
                ) : (
                  <p style={{ fontSize: "14px", color: "red" }}>No slots available</p>
                )}
              </div>
            </div>
          )}
        </div>
      

      </div>

      {/* Appointment Form */}
      <div ref={formRef} className="mt-8">
        {isAppointmentFormVisible && selectedSlot && (
          <AppointmentForm selectedDate={selectedDate} selectedSlot={selectedSlot} />
        )}
      </div>
    </>
  );
}

export default AddAppointment;